import React, {Fragment, useContext} from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import {ProviderRequestsContext} from "../../context/ProviderRequestsContext";

import { ReactComponent as ProviderConfirmationSvg } from '../../assets/provider-confirmation.svg';
import { ReactComponent as CheckIconSvg } from '../../assets/check-icon.svg';

export default function ConfirmProviderTypes(props) {
    const { classes, consentTerms, handleConsentTerms } = props;
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const selectedProviders = providerRequestsContext.state.selectedProviders;

    return (
        <Fragment>
            <Grid container spacing={2} noValidate className={`${classes.inputContainer} ${classes.mb40}`}>
                <Grid item sm={12} className={`${classes.noPadding}`}>
                    <ProviderConfirmationSvg className={`${classes.center} ${classes.img} ${classes.mb40}`} />
                    <Paper square elevation={0} className={classes.inputTitleContainer}>
                        <Typography className={classes.inputTitleText}>Vei fi contactat cel mai curând</Typography>
                        <Typography className={`${classes.mb8} ${classes.subTitle}`}>După confirmare te vom pune în legatură cu:</Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} className={classes.noPadding}>
                    <ul className={classes.list}>
                        {selectedProviders.map((category) => (            
                            <li key={category.code}>
                                <CheckIconSvg />
                                {category.name}
                            </li>
                        ))}
                    </ul>
                    <FormControlLabel
                        required
                        className={classes.checkbox}
                        control={
                            <Checkbox
                            checked={consentTerms}
                            onChange={handleConsentTerms}
                            name="consentTerms"
                            color="primary"
                            checkedIcon={<CheckIconSvg />}
                            />
                        }
                        label={<label>Accept <a href='/termeni-si-conditii' target="_blank"> termenii și condițiile</a></label>}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}